import config from "@/config"
import http from "@/utils/request"
import tool from "@/utils/tool"

export default {
	upload: {
		url: `${config.API_URL}/upload`,
		name: "文件上传",
		post: async function (data, config = {}) {
			if (data instanceof FormData) {
				let token = tool.data.get("TOKEN");
				if (token) {
					data.append('token', token);
				}
				data.append('appid', '91713788');
				data.append('platform', 'pc');
				let signParams = {};
				data.forEach((value, key) => {
					if (!(value instanceof File) && typeof value !== 'object') {
						signParams[key] = value;
					}
				});
				// console.log(signParams);
				data.append('sign', tool.getSign(signParams));
			}
			return await http.post(this.url, data, config);
		}
	},
	uploadFile: {
		url: `${config.API_URL}/upload`,
		name: "附件上传",
		post: async function (data, config = {}) {
			if (data instanceof FormData) {
				let token = tool.data.get("TOKEN");
				if (token) {
					data.append('token', token);
				}
				data.append('appid', '91713788');
				data.append('platform', 'pc');
				let signParams = {};
				data.forEach((value, key) => {
					if (!(value instanceof File) && typeof value !== 'object') {
						signParams[key] = value;
					}
				});
				data.append('sign', tool.getSign(signParams));
			}
			return await http.post(this.url, data, config);
		}
	},
	uploadVideo: {
		url: `${config.API_URL}/upload?method=set.upload.video.figure`,
		name: "附件上传",
		post: async function (data, config = {}) {
			if (data instanceof FormData) {
				let token = tool.data.get("TOKEN");
				if (token) {
					data.append('token', token);
				}
				data.append('appid', '91713788');
				data.append('platform', 'pc');
				let signParams = {};
				data.forEach((value, key) => {
					if (!(value instanceof File) && typeof value !== 'object') {
						signParams[key] = value;
					}
				});
				data.append('sign', tool.getSign(signParams));
			}
			return await http.post(this.url, data, config);
		}
	},
	exportFile: {
		url: `${config.API_URL}/fileExport`,
		name: "导出附件",
		get: async function (data, config = {}) {
			return await http.get(this.url, data, config);
		}
	},
	importFile: {
		url: `${config.API_URL}/fileImport`,
		name: "导入附件",
		post: async function (data, config = {}) {
			if (data instanceof FormData) {
				let token = tool.data.get("TOKEN");
				if (token) {
					data.append('token', token);
				}
				data.append('appid', '91713788');
				data.append('platform', 'pc');
				let signParams = {};
				data.forEach((value, key) => {
					if (!(value instanceof File) && typeof value !== 'object') {
						signParams[key] = value;
					}
				});
				data.append('sign', tool.getSign(signParams));
			}
			return await http.post(this.url, data, config);
		}
	},
	file: {
		menu: {
			url: `${config.API_URL}/storage`,
			name: "获取文件分类",
			post: async function (data) {
				return await http.post(this.url, { method: 'get.storage.directory.select', ...data });
			}
		},
		list: {
			url: `${config.API_URL}/storage`,
			name: "获取文件列表",
			post: async function (data) {
				return await http.post(this.url, { method: 'get.storage.list', ...data });
			}
		},
		collection: {
			url: `${config.API_URL}/storage`,
			name: "获取文件列表",
			post: async function (data) {
				return await http.post(this.url, { method: 'get.storage.collection', ...data });
			}
		},
		addMenu: {
			url: `${config.API_URL}/storage`,
			name: "新增文件目录",
			post: async function (data) {
				return await http.post(this.url, { method: 'add.storage.directory.item', ...data });
			}
		},
		menuNavi: {
			url: `${config.API_URL}/storage`,
			name: "新增文件目录",
			post: async function (storage_id, is_layer = 1) {
				return await http.post(this.url, {
					method: 'get.storage.navi', storage_id,
					is_layer
				});
			}
		},
		setFile: {
			url: `${config.API_URL}/storage`,
			name: "编辑一个文件",
			post: async function (data) {
				return await http.post(this.url, { method: 'rename.storage.item', ...data });
			}
		},
		moveFile: {
			url: `${config.API_URL}/storage`,
			name: "移动一个文件",
			post: async function (storage_id, parent_id) {
				return await http.post(this.url, { method: 'move.storage.list', storage_id, parent_id });
			}
		},
		delFile: {
			url: `${config.API_URL}/storage`,
			name: "移动一个文件",
			post: async function (storage_id) {
				return await http.post(this.url, { method: 'del.storage.list', storage_id });
			}
		}
	},
	setting: {
		url: `${config.API_URL}/setting`,
		name: "系统配置",
		get: async function (data = {}, config = {}) {
			return await http.post(this.url, { method: 'get.setting.bottom.list', auth: false, ...data }, config);
		}
	},
	home: {
		url: `${config.API_URL}/home`,
		name: "首页数据",
		get: async function (data = {}, config = {}) {
			return await http.post(this.url, { method: 'get.index.list', auth: false, ...data }, config);
		}
	},

}
